import { Link, useMatches } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

const ROUTE_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  '/pipeline': 'Pipeline',
  '/deals': 'Deals',
  '/deals/new': 'New Deal',
  '/commissions': 'Commissions',
  '/commissions/calculator': 'Calculator',
  '/commissions/plans': 'Plans',
  '/team': 'Team',
  '/team/invite': 'Invite',
  '/settings': 'Settings',
  '/settings/pipeline': 'Pipeline',
  '/settings/integrations': 'Integrations',
  '/settings/billing': 'Billing',
  '/reports': 'Reports',
  '/reports/leaderboard': 'Leaderboard',
};

export function Breadcrumbs() {
  const matches = useMatches();

  const crumbs = matches
    .filter((m) => m.pathname !== '/' || matches.length === 1)
    .map((m) => ({
      path: m.pathname,
      label: ROUTE_LABELS[m.pathname] ?? m.pathname.split('/').pop() ?? '',
    }))
    .filter((c) => c.label);

  if (crumbs.length <= 1) {
    return (
      <h2 className="text-sm font-medium text-muted-foreground">
        {crumbs[0]?.label ?? 'Dashboard'}
      </h2>
    );
  }

  return (
    <nav className="flex items-center gap-1 text-sm">
      {crumbs.map((crumb, i) => (
        <div key={crumb.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3 w-3 text-muted-foreground" />}
          {i < crumbs.length - 1 ? (
            <Link
              to={crumb.path}
              className="text-muted-foreground hover:text-foreground"
            >
              {crumb.label}
            </Link>
          ) : (
            <span className="font-medium">{crumb.label}</span>
          )}
        </div>
      ))}
    </nav>
  );
}
